/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const SegmentsIcon = ({ width = 24, height = 24, hidden = false, title = 'Segments' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M11.118 14h23.764A1.119 1.119 0 0 0 36 12.882V5.118A1.118 1.118 0 0 0 34.882 4H11.118A1.118 1.118 0 0 0 10 5.118V8H6a2 2 0 0 0-2 2v3.1a5 5 0 0 0 0 9.8V26a2 2 0 0 0 2 2h4v2.882A1.119 1.119 0 0 0 11.118 32h23.764A1.119 1.119 0 0 0 36 30.882v-7.764A1.118 1.118 0 0 0 34.882 22H11.118A1.118 1.118 0 0 0 10 23.118V26H6v-3.1a5 5 0 0 0 0-9.8V10h4v2.882A1.119 1.119 0 0 0 11.118 14ZM8 18a3 3 0 1 1-3-3 3 3 0 0 1 3 3Z"
    />
  </svg>`;
};
